import { render, staticRenderFns } from "./ChangeRequest.vue?vue&type=template&id=c41a57fc"
import script from "./ChangeRequest.vue?vue&type=script&lang=js"
export * from "./ChangeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports